/** The fragment stays out of HTTP requests and Referer headers. */
export function invitationLink(token: string): string {
  return `${window.location.origin}/leagues#invitation=${encodeURIComponent(token)}`;
}
export function invitationToken(value: string): string {
  const raw = value.trim();
  if (/^[A-Za-z0-9_-]{43}$/.test(raw)) return raw;
  try {
    const url = new URL(raw, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname !== '/leagues') return '';
    const token = new URLSearchParams(url.hash.slice(1)).get('invitation') || '';
    return /^[A-Za-z0-9_-]{43}$/.test(token) ? token : '';
  } catch { return ''; }
}
